module.exports = __webpack_public_path__ + "static/logo-5913bee1fd52fae16e019e3bc05d81c0.svg";